<template lang="pug">
.other-facilities-application-modal
  b-modal(v-model="_value" size="xl" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
    div(slot="modal-title")
      span {{ waiterName }} 様の他施設の申込み状況
    
    .mb-3
    OtherFacilitiesApplicationTable(v-model="items" :fields="fields" :isLoading="isLoading")

    template(#modal-footer="{ cancel }")
      b-button.btn.modal-cancel-btn(@click="cancel") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import OtherFacilitiesApplicationTable, {
  OtherFacilitiesApplicationTableField,
  OtherFacilitiesApplicationTableItem
} from "@/pc/containers/waiters/OtherFacilitiesApplicationTable.vue";

/**
 * ### 他施設の判定結果モーダル
 */
@Component({
  components: {
    OtherFacilitiesApplicationTable
  }
})
export default class OtherFacilitiesApplicationModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルタイトルで使用する待機者名 */
  @Prop()
  waiterName!: string;
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  items!: Array<OtherFacilitiesApplicationTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OtherFacilitiesApplicationTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public cancel(): void {
    return;
  }
}
</script>

<style lang="scss" scoped></style>
